import Stack from '@/components/Custom/ModalStack';

export default function PrivateChatCreateDirectLayoutRoute() {
  return <Stack />;
}
